import React from 'react';
import { getData, deleteData, } from '../../../core/HttpAction';
import Table from '../../../core/Table'; 
import {withRouter,Link} from 'react-router-dom';
import {permissionCheck} from '../../../core/Permission';

const Url='/bookcategory';

const CellColumn=({props,row})=>{
    return <Link to={`${props.match.url}/${row.book_category_id}`}><span className="uk-badge">View</span></Link>;
};
const role=permissionCheck('bookcategory','DetailView');
 
const columns=role?[
    {
        key:'name',
        displayName:'Book Type'
    },
    { 
        key:'access_key',
        displayName:'Access Key'
    }, 
    {
        key:'action',
        displayName:'View',
        Cell:CellColumn
    }
]:[
    {
        key:'name',
        displayName:'Book Type'
    },
    { 
        key:'access_key',
        displayName:'Access Key'
    }
];
  
class ListPage extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'', 
                limit:10,
                page:1
            }, 
            data:[],
            preloader:true,
        };
        this.fetchData = this.fetchData.bind(this);  
        this.handleFetch = this.handleFetch.bind(this);  
        this.delete = this.delete.bind(this);  
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData(){
        getData(Url,this.state.params).then((res)=>{ 
            this.setState({data:res.data,preloader:false}); 
        });
    }

    handleFetch(params){
        this.setState({params:{...params},preloader:true},()=>{
            this.fetchData();
        });
    }

    delete(id){
        let page=1;
        this.setState({preloader:true,params:{...this.state.params,page}});
        deleteData(Url+'/'+id).then((res)=>{
            if(res.data.status===200){
                this.fetchData();
            }else{
                alert('Not delete');
                this.setState({preloader:false});
            }
        });   
    }
    render() {
        let {preloader,data}=this.state; 
        return (
            <Table
                data={data}
                handleFetch={this.handleFetch.bind(this)}
                preloader={preloader}
                permission="bookcategory"
                title="Book Category"
                columns={columns}
                primaryKey="book_category_id"
                addEditUrl={`${this.props.match.url}-action`} 
                delete={this.delete.bind(this)}
            /> 
        );
    }
}
 
export default  withRouter(ListPage); 



// WEBPACK FOOTER //
// ./src/components/Library/BookCategory/index.js